<template>
    <div class="carddesign card h-100">
        <div class="card-header" v-html="$strings('main.tiles.HelpFeedback.title')"></div>
        <div class="card-body">
            <p class="card-text" v-html="$strings('main.tiles.HelpFeedback.description')"></p>
            <router-link class="btn btn-primary"
                :to="{ name: $strings('main.tiles.HelpFeedback.link') }">{{ $strings('main.tiles.HelpFeedback.linkTitle') }}&nbsp;<i class="bi bi-arrow-right"></i></router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HelpFeedbackTile',
        methods: {}
    };
</script>

<style scoped>
</style>
